// eslint-disable-next-line import/prefer-default-export
export const GET_ORDER = 'GET_ORDER';
export const GET_ORDER_PAYMENT_STATUS = 'GET_ORDER_PAYMENT_STATUS';
export const RESET_ORDER = 'RESET_ORDER';
export const RESET_ORDER_PAYMENT_STATUS = 'RESET_ORDER_PAYMENT_STATUS';
